import Styles from 'components/WorkspaceDashboard/WorkspaceDashboard.module.scss'
import VideoEditorStyles from './VideoEditorDashboard.module.scss'
import { VideoEditorDashboardProps } from './Types'
import { VideoEditorHeader } from 'blaze-components/WorkspaceDashboardHeader/VideoEditorHeader'
import { Redirect, useRouteMatch } from 'react-router-dom'
import { HOME_PATH, VIDEO_PATH } from 'paths'
import { WorkspaceDashboardSidebar } from 'blaze-components/WorkspaceDashboardSidebar/WorkspaceDashboardSidebar'
import { useSidebarState } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useSidebarState'
import { observer } from 'mobx-react-lite'
import SettingsContainer from 'components/Settings/SettingsContainer'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { DocRightPanelWrapper } from 'components/DocRightPanelWrapper/DocRightPanelWrapper'
import cx from 'classnames'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'
import { MobileStopForStrategies } from 'components/MobileStop/MobileStopForStrategies'
import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'

const VideoEditorDashboard = observer(({ workspace, children }: VideoEditorDashboardProps) => {
  const fileId = useRouteMatch<{ key: string }>(VIDEO_PATH)?.params.key
  const sidebarState = useSidebarState()
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const isAPMobileWeb = useAPMobileWeb()
  const { data: brandPlan } = useCurrentBrandPlan()

  if (!fileId) {
    return <Redirect to={HOME_PATH} />
  }

  if (isAPMobileWeb && brandPlan?.has_content_strategies) {
    return <MobileStopForStrategies />
  }

  return (
    <div className={cx(Styles.dashboard, VideoEditorStyles.dashboard)} id="workspace-dashboard">
      {sidebarState.isVisible && <WorkspaceDashboardSidebar />}
      <div className={cx(Styles.innerContent, { [Styles.isDesignerDashboard]: isSystemRedesignEnabled })}>
        <VideoEditorHeader fileId={fileId} />
        {children}
        <SettingsContainer workspace={workspace} />
      </div>
      <ResponsiveDesign.Desktop>
        <DocRightPanelWrapper />
      </ResponsiveDesign.Desktop>
    </div>
  )
})

export { VideoEditorDashboard }
